import {
    pxToRem,
    useStyles,
    useTheme,
    VariantColor,
} from '@archipro-design/aria';
import { CheckLine } from '@archipro-design/icons';
import React from 'react';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import * as S from './ColorOption.style';
import type AttributeOption from '@modules/product/type/attribute-option';

interface ColorOptionProps
    extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onSelect'> {
    data: {
        option: AttributeOption;
    };
    selected: boolean;
    onSelect(option: AttributeOption): void;
    size?: number;
    spacing?: number;
}

const ColorOption = ({
    data: { option },
    selected,
    onSelect,
    size = 80,
    spacing = 12,
}: ColorOptionProps) => {
    const { css } = useStyles();
    const theme = useTheme();

    const onClick = () => {
        onSelect(option);
    };

    const { mobile } = useAppDisplayModeContext();
    const imageUrl = option.Image
        ? mobile
            ? option.Image.Mobile
            : option.Image.Desktop
        : null;
    const image = imageUrl
        ? {
              width: size,
              height: size,
              src: imageUrl,
              alt: option.Label || '',
              style: { backgroundColor: 'transparent' },
          }
        : null;

    return (
        <div
            role={'option'}
            aria-selected={selected}
            className={css(S.ColorOption)}
            onClick={onClick}
        >
            <VariantColor
                colorCode={image ? undefined : option.Code || ''}
                size={size + spacing}
                description={'colour ' + option.Label}
                image={image}
                highlighted={selected}
                variables={{
                    border: `${pxToRem(2)} solid transparent`,
                    containerBorder: `${pxToRem(4)} solid transparent`,
                    ringColor: theme.siteVariables.colors.charcoal[250],
                }}
            />
            {selected && (
                <div className={css(S.CheckMark)}>
                    <CheckLine />
                </div>
            )}
            <label>{option.Label}</label>
        </div>
    );
};

export default ColorOption;
